module.exports = __webpack_public_path__ + "img/pipe-hover.3ee51e44.png";